// extracted by mini-css-extract-plugin
export default {"wrapper":"SMIM7o_Z8vQTdKgw0t9M","table":"pp9RY49VHIWCi6whe8Ay","header":"v2HysXHSzYhHNlRLfi9l","spinnerContainer":"xXQrb81myoorMpWykdJS","fadeIn":"MxsGlNc8s4XOl0GPLUDk"};